module.exports = __webpack_public_path__ + "img/bussola.3af926ae.png";